export default {
  search_placeholder: "Rechercher dans les FAQ...",
  no_results_title: "Aucun résultat trouvé",
  no_results_subtitle:
    "Essayez d'ajuster vos mots-clés de recherche ou parcourez les catégories sur la gauche.",
  search_cleared_message: "Recherche effacée pour afficher le contenu complet",
  still_have_questions: {
    before_email: "Vous avez encore des questions ? Contactez-nous à ",
    after_email: " — notre équipe répondra dans un délai de 24 heures.",
  },
};
